 <div
    class="template__wrapper"
    [class.test-mode-template]="isTestMode"
    (click)="onTemplateClick()">
    <div class="template" [class.vertical-centered]="forPrint">
      <lib-cfs-template-preview
        [responsive]="responsive"
        [template]="template"
        [animationType]="animationType"
        [isPrintView]="forPrint"
        [fullMediaConfig]="fullMediaConfig"
        [isLowResolutionScreen]="isLowResolutionScreen"
        (printReady)="print.emit()"
        (ready)="ready.emit()"
        (error)="error.emit($event)">
      </lib-cfs-template-preview>
    </div>
  </div>

<div *ngIf="isTestMode" class="test-mode-info">
  <span *ngIf="contentDuration">Content duration: {{ contentDuration / 1000 }}; </span>
  <span *ngIf="displayTime">Display Time: {{ displayTime / 1000 }}; </span>

  <ng-content></ng-content>
</div>
